/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=696c0e72&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=696c0e72&lang=css"
import "./index.vue?vue&type=style&index=1&id=696c0e72&lang=less&scoped=true"

import exportComponent from "D:\\work\\2025\\yddh\\web\\xsspm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-696c0e72"]])

export default __exports__